export default __webpack_public_path__ + "static/careers-tabby-awards-8bf6bf57781d2046d35b29fe020146e7.png";